export interface AccountingBasis {
	id: number;
	name: string;
}

export const ALL_ACCOUNTING_BASES = 'all';
export type AllAccountingBases = typeof ALL_ACCOUNTING_BASES;
export type SelectedAccountingBases = AllAccountingBases | number[];

